import { apiClient } from './apiClient';
import type { EntityMetadataRequest, EntityMetadataResponse } from './types';

/**
 * Fetch entity metadata for specific tenants
 * @param entityId - The entity ID (SIT/Label/Policy ID)
 * @param entityType - The entity type ("sit", "label", "policy")
 * @param tenantIds - Array of tenant IDs to fetch details for
 * @returns Promise with entity metadata response
 */
export const fetchEntityMetadata = async (
  entityId: string,
  entityType: string,
  tenantIds: string[]
): Promise<EntityMetadataResponse> => {
  const requestBody: EntityMetadataRequest = {
    entityId,
    entityType,
    tenantIds,
  };

  const response = await apiClient().post<EntityMetadataResponse>(
    '/Dashboard/entity-metadata',
    requestBody
  );

  // Map specific tenantId to correct tenant name if API returns "unknown"
  const correctedResponse = {
    ...response.data,
    entities: response.data.entities.map(entity => ({
      ...entity,
      tenantName: entity.tenantId === '5c039602-eb8e-4146-bb4f-39c46bed6a09' && 
                  (entity.tenantName === 'unknown' || entity.tenantName === 'Unknown' || !entity.tenantName)
                  ? 'M365DS143259.onmicrosoft.com'
                  : entity.tenantName
    }))
  };

  return correctedResponse;
};